<div class="row se-progress-bar">
    <div class="col-sm-12">
        <self-evaluation-progressbar-component *ngIf="itemsGroup.length"
                                               [step]=5
                                               [activePage]="activePage"
                                               [total]="totalPage">
        </self-evaluation-progressbar-component>
    </div>
</div>
<div id="top-el"></div>
<div tabindex="0" class="wrapper wrapper__selfevaluation amnestic-feeling-selection user-select-none clearfix"
     [hidden]="itemsGroup.length == 0"
     [ngStyle]="deviceInnerHeight > 0 ?
        {
            'min-height': deviceInnerHeight + 'px'
        } : ''">
    <div class="row header-title">
        <div class="col-sm-7 col-xs-10">
            <h1 class="wrapper__title wrapper__title--normal">
                {{ pageTypes[appService.SEType]['contentHeader'][currentStep] | translate}}
            </h1>
        </div>
        <div class="col-sm-5 col-xs-2 header-title__info">
        </div>
        <div class="col-sm-12 wrapper__pagination hidden">
            <span class="pull-right text-right" *ngIf="activePage && totalPage">{{ activePage }}/{{ totalPage }}</span>
        </div>
    </div>
    <div class="feeling-block row" *ngFor="let group of itemsGroup; let groupIndex = index" [ngClass]="{'active':(groupIndex+1) == activePage}">
        <div class="col-sm-12" *ngFor="let item of group; let itemIndex = index">
            <div class="row feeling-item"
                 [ngClass]="{'active': selectedIds.indexOf(item.id) > -1}">
                <div class="col-xs-12 feeling-item__label"
                    [ngClass]="!item.feeling_id || currentStep === appService.steps.ANAMESTIC_SELECTION ? 'col-sm-12' : 'col-sm-7'"
                    (click)="selectQuestion(item)"
                    (keyup.enter)="selectQuestion(item)"
                    tabindex="0">
                    <input type="radio"
                           id="feeling-{{item.id}}"
                           [checked]="item.id && selectedIds && (selectedIds.indexOf(item.id) > -1)"
                    />
                    <label for="feeling-{{item.id}}">
                        {{ item['statement_' + lang] }}
                    </label>
                </div>
                <div class="col-xs-12 col-sm-5 mat-slider"
                     *ngIf="item.feeling_id && currentStep !== appService.steps.ANAMESTIC_SELECTION"
                     [class.hidden]="appService.isMobile && (!item.selected || item.selected < 1 || !item.feeling_id || currentStep === appService.steps.ANAMESTIC_SELECTION)">
                    <mat-slider showTickMarks class="mat-slider--rating"
                                (keyup.enter)="selectQuestion(item)"
                                [ngClass]="item.id && selectedIds.indexOf(item.id) > -1 ? 'selected' : 'not-selected'"
                                [class.disabled]="!item.feeling_id  || selectedIds.indexOf(item.id) < 0"
                                [class.hidden]="!item.feeling_id || currentStep === appService.steps.ANAMESTIC_SELECTION"
                                [(ngModel)]="item.rating"
                                [min]="2" [max]="99" [step]="1"
                                id="mat-slider--feeling--{{item.feeling_id}}"
                                [value]="item.rating || RATING_MIN"
                                (change)="onRatingChange($event, item)">
                    </mat-slider>
                    <div class="mat-slider--label"
                         [class.hidden]="!item.feeling_id || currentStep === appService.steps.ANAMESTIC_SELECTION"
                         [class.disabled]="!item.feeling_id  || selectedIds.indexOf(item.id) < 0 || !item.selected"
                    >
                        <label class="mat-slider--label">{{ 'Mild strain' | translate}}</label>
                        <label class="mat-slider--label pull-right">{{ 'Severe strain' | translate}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row wrapper__btns">
        <div class="col-sm-12 slide-navigator">
            <button [class.hidden]="activePage === 1" *ngIf="!isLoading" (click)="backPreviousPage()" type="submit" class="btn btn-secondary badge-pill pd-v--sm">
                {{ 'Back' | translate }}
            </button>
            <button (click)="openConfirm()" type="submit" class="hidden-sm-up btn color-primary btn--pause bg--none br--none pull-right">
                <i class="fal fa-pause-circle"></i>
            </button>
            <button [class.hidden]="groupSelectedCount[activePage]"
                    *ngIf="!isLoading"
                    type="submit" class="btn btn-primary badge-pill pd-v--sm pull-right"
                    (click)="setIsRedirectedFromAmnestic(); saveAndGoNextPage()">
                <i class="fas fa-angle-right fa-2x"></i>
                {{ 'None Applies to Me' | translate }}
            </button>
            <button  *ngIf="!isLoading"
                     (click)="setIsRedirectedFromAmnestic(); saveAndGoNextPage()" type="submit"
                     [class.hidden]="!groupSelectedCount[activePage]"
                     class="btn btn-primary badge-pill pd-v--sm pull-right">
                <i class="fas fa-angle-right fa-2x"></i>
                {{ 'Next' | translate }}
            </button>
            <button (click)="openConfirm()" type="submit" class="hidden-xs-down btn btn--tertiary bg--none br--none badge-pill pd-v--sm btn-xs-full pull-right text-regular btn--continue">
                <i class="fal fa-pause-circle"></i>
                {{ 'Continue later' | translate }}
            </button>
        </div>
    </div>
    <self-evaluation-confirm-modal-component #confirmModal [isStudy] = "isStudy" [isIntroducePage]="false" (confirmContinueLater)="continueLaterSubmit()"></self-evaluation-confirm-modal-component>
</div>
